import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

export default function Signout({ onClose }) {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const preloading = document.getElementById("preloading");
    setTimeout(() => {
      if (preloading) {
        preloading.style.display = "none";
      }
    }, 400);

    // Show the modal on component mount
    setShow(true);
  }, []);

  const handleClose = () => {
    setShow(false);
    onClose();
  };
  const handleSignout = () => {
    setShow(false);
    // Redirect to the home page
    navigate("/");
    localStorage.removeItem('userDetails');
  };

  return (
    <div>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Ready to Leave?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Select "<b>Signout</b>" below if you are ready to end your current
          session.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSignout}>
            <i class="icofont-logout"></i> Signout
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}


